import { render, staticRenderFns } from "./InputTel.vue?vue&type=template&id=2fd7e678&"
import script from "./InputTel.vue?vue&type=script&lang=js&"
export * from "./InputTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd7e678')) {
      api.createRecord('2fd7e678', component.options)
    } else {
      api.reload('2fd7e678', component.options)
    }
    module.hot.accept("./InputTel.vue?vue&type=template&id=2fd7e678&", function () {
      api.rerender('2fd7e678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/InputTel/InputTel.vue"
export default component.exports